import { render, staticRenderFns } from "./videoupload.vue?vue&type=template&id=6b71fa48&scoped=true&"
import script from "./videoupload.vue?vue&type=script&lang=js&"
export * from "./videoupload.vue?vue&type=script&lang=js&"
import style0 from "./videoupload.vue?vue&type=style&index=0&id=6b71fa48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b71fa48",
  null
  
)

export default component.exports